import {
  DeleteOutlined,
  FilterOutlined,
  InsertRowLeftOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  Popconfirm,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import { Option } from "antd/lib/mentions";
import { debounce } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { deleteRequest, getRequest, patchRequest } from "../../../axios";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import { ReactComponent as Editicon } from "../../../image/Editicon.svg";
import PlusSquareOutlined from "../../../image/PlusSquareOutlined.svg";
import SearchIcon from "../../../image/SearchIcon.svg";
import "../../../styles/Main.scss";
import { authUserData } from "../../../utils/Helper";
import { ReactComponent as ArchiveButtonicon } from "../../../image/ArchiveButtonicon.svg";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
import Deliveryrate from "./DeliveryRate";
const { Search } = Input;

const DeliveryRateList = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deliveryrates, setdeliveryrates] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState([]);
  const [zoneList, setZoneList] = useState([]);
  const [reload, setReload] = useState(false);
  const [deliveryratesID, setdeliveryratesID] = useState(null);
  const [modalKey, setModalKey] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const [state, setState] = useState({
    page: 1,
    ordering: "-id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getPincodeList = async () => {
      setLoading(true);

      const queryParamsObject = {
        country: stateFilter?.country || null,
        company: stateFilter?.company || null,
        start_weight: stateFilter?.start_weight || null,
        start_weight_unit_of_measurement:
          stateFilter?.start_weight_unit_of_measurement || null,
        end_weight: stateFilter?.end_weight || null,
        end_weight_unit_of_measurement:
          stateFilter?.end_weight_unit_of_measurement || null,
        price: stateFilter?.price || null,
        page: state.page,
        ordering: state.ordering,
        pagesize: state.pagesize,
        search: state.search,
        total: state.total,
      };

      const queryParams = new URLSearchParams(
        Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
          if (value !== null && value !== undefined) {
            acc[key] = value;
          }
          return acc;
        }, {})
      ).toString();

      const payload = {
        zone_name: stateFilter?.zone_name || [],
        state_name: stateFilter?.state_name || [],
      };

      try {
        let apiResponse = await patchRequest(
          `delivery-rates/?${queryParams}`,
          payload
        );
        if (apiResponse.data.results.success) {
          setdeliveryrates(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        }
      } catch (error) {
        ErrorNotificationMsg(t("Error Fetching Delivery"));
      } finally {
        setLoading(false);
      }
    };

    getPincodeList();
  }, [state, reload, t]);

  useEffect(() => {
    getZoneList();
  }, []);

  const getZoneList = async (data) => {
    await getRequest("delivery-rates/", data).then((response) => {
      setZoneList(response.data.data);
    });
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });
    form.setFieldsValue({ search: "" });
  };
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "-id";

    if (sortField === "country_name" && sortOrder === "ascend") {
      sortingEnumKey = "country__name";
    }
    if (sortField === "country_name" && sortOrder === "descend") {
      sortingEnumKey = "-country__name";
    }
    if (sortField === "state_name" && sortOrder === "ascend") {
      sortingEnumKey = "state__name";
    }
    if (sortField === "state_name" && sortOrder === "descend") {
      sortingEnumKey = "-state__name";
    }
    if (sortField === "street" && sortOrder === "ascend") {
      sortingEnumKey = "street_name";
    }
    if (sortField === "street" && sortOrder === "descend") {
      sortingEnumKey = "-street_name";
    }
    if (sortField === "city" && sortOrder === "ascend") {
      sortingEnumKey = "city__name";
    }
    if (sortField === "city" && sortOrder === "descend") {
      sortingEnumKey = "-city__name";
    }

    if (sortField === "zone_name" && sortOrder === "ascend") {
      sortingEnumKey = "zone__zone";
    }
    if (sortField === "zone_name" && sortOrder === "descend") {
      sortingEnumKey = "-zone__zone";
    }
    if (sortField === "currency" && sortOrder === "ascend") {
      sortingEnumKey = "currency";
    }
    if (sortField === "currency" && sortOrder === "descend") {
      sortingEnumKey = "-currency";
    }

    if (sortField === "price" && sortOrder === "ascend") {
      sortingEnumKey = "price";
    }
    if (sortField === "price" && sortOrder === "descend") {
      sortingEnumKey = "-price";
    }
    if (sortField === "company_name" && sortOrder === "ascend") {
      sortingEnumKey = "company__company_name";
    }
    if (sortField === "company_name" && sortOrder === "descend") {
      sortingEnumKey = "-company__company_name";
    }
    if (
      sortField === "start_weight_unit_of_measurement_name" &&
      sortOrder === "ascend"
    ) {
      sortingEnumKey = "start_weight_unit_of_measurement__name";
    }
    if (
      sortField === "start_weight_unit_of_measurement_name" &&
      sortOrder === "descend"
    ) {
      sortingEnumKey = "-start_weight_unit_of_measurement__name";
    }
    if (
      sortField === "end_weight_unit_of_measurement_name" &&
      sortOrder === "ascend"
    ) {
      sortingEnumKey = "end_weight_unit_of_measurement__name";
    }
    if (
      sortField === "end_weight_unit_of_measurement_name" &&
      sortOrder === "descend"
    ) {
      sortingEnumKey = "-end_weight_unit_of_measurement__name";
    }
    if (sortField === "end_weight" && sortOrder === "ascend") {
      sortingEnumKey = "end_weight";
    }
    if (sortField === "end_weight" && sortOrder === "descend") {
      sortingEnumKey = "-end_weight";
    }
    if (sortField === "start_weight" && sortOrder === "ascend") {
      sortingEnumKey = "start_weight";
    }
    if (sortField === "start_weight" && sortOrder === "descend") {
      sortingEnumKey = "-start_weight";
    }
    if (sortField === "start_weight" && sortOrder === "ascend") {
      sortingEnumKey = "start_weight";
    }
    if (sortField === "start_weight" && sortOrder === "descend") {
      sortingEnumKey = "-start_weight";
    }
    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  const [checkedList, setCheckedList] = useState([
    "country_name",
    "state_name",
    "zone_name",
    "company_name",
    "start_weight",
    "start_weight_unit_of_measurement_name",
    "end_weight",
    "end_weight_unit_of_measurement_name",
    "price",
    "currency",
    "operation",
  ]);

  const currencySymbols = {
    USD: "$",
    EUR: "€",
    JPY: "¥",
    INR: "₹",
    // Add more currencies as needed
  };

  const fetchCurrencySymbol = (currencyCode) => {
    return currencySymbols[currencyCode] || "$";
  };

  const [columns, setColumns] = useState([
    {
      title: "Country",
      dataIndex: "country_name",
      key: "country_name",
      sorter: true,
    },
    {
      title: "State",
      dataIndex: "state_name",
      key: "state_name",
      sorter: true,
    },
    {
      title: "Run",
      dataIndex: "zone_name",
      key: "zone_name",
      sorter: true,
    },
    {
      title: "Company",
      dataIndex: "company_name",
      key: "company_name",
      sorter: true,
    },
    {
      title: "From Weight",
      dataIndex: "start_weight",
      key: "start_weight",
      sorter: true,
    },
    {
      title: "UoM.",
      dataIndex: "start_weight_unit_of_measurement_name",
      key: "start_weight_unit_of_measurement_name",
      sorter: true,
    },
    {
      title: "To Weight ",
      dataIndex: "end_weight",
      key: "end_weight",
      sorter: true,
    },
    {
      title: "UoM.",
      dataIndex: "end_weight_unit_of_measurement_name",
      key: "end_weight_unit_of_measurement_name",
      sorter: true,
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      sorter: true,
      render: (price, record) => (
        <span>
          {fetchCurrencySymbol(record.currency)} {price}
        </span>
      ),
    },
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency",
      sorter: true,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: "100px",
      render: (text, record) => (
        <Space>
          {/* <Tooltip title="Edit" placement="left" color={colors}> */}
          {authUserData()?.permission.includes(
            "settings|change_deliveryrates"
          ) && (
            <Editicon
              onClick={() => handleUpdate(record.id)}
              style={{ cursor: "pointer" }}
            />
          )}
          {/* </Tooltip> */}
          {/* <Tooltip title="Delete" placement="right" color={colors}> */}
          {authUserData()?.permission.includes(
            "settings|delete_deliveryrates"
          ) && (
            <Popconfirm
              title={t("pop_delete")}
              okText={t("pop_ok")}
              cancelText={t("pop_cancel")}
              onConfirm={() => handleArchive(record.id)}
            >
              <DeleteOutlined style={{ cursor: "pointer" }} />
            </Popconfirm>
          )}
          {/* </Tooltip> */}
        </Space>
      ),
    },
  ]);

  useEffect(() => {
    const updatedColumns = columns.map((column) => ({
      ...column,
      hidden: !checkedList.includes(column.key),
    }));
    setColumns(updatedColumns);
  }, [checkedList, columns]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  const columnMenu = (
    <Menu>
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            <Col span={12}>
              <Checkbox value="country_name">Country</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="state_name">State</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="zone_name">Zone</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="company_name">Company</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="start_weight">From Weight</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="start_weight_unit_of_measurement_name">
                Uom.
              </Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="end_weight">To Weight</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="end_weight_unit_of_measurement_name">
                Uom.
              </Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="price">Price</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="currency">Currency</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="operation" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const handleUpdate = (id) => {
    setModalKey((prevKey) => !prevKey);
    setdeliveryratesID(id);
    showModal();
  };
  const handleAdd = () => {
    setdeliveryratesID(null);
    showModal();
  };

  const handleArchive = async (id = []) => {
    let ids = [...selectedRow];
    if (ids.length === 0 && id) {
      ids.push(id);
    }
    try {
      let apiResponse = await deleteRequest(
        "delivery-rates/delivery-rate-delete/",
        {
          deleted: ids,
        }
      );
      if (apiResponse.data.success) {
        let totalArchive = totalCount - ids.length;
        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("Delivery Rate Deleted Successfully"));
        // setReload(!reload);
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("Error In Deleted Delivery Rate"));
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [isModalOpenBulk, setIsModalOpenBulk] = useState(false);
  const handleOkBulk = () => {
    setIsModalOpenBulk(false);
  };
  const handleCancelBulk = () => {
    setIsModalOpenBulk(false);
  };

  const handleChange = (field, value) => {
    setStateFilter({ ...stateFilter, [field]: value.target.value });
  };

  const intialFilter = {
    country: "",
    company: "",
    zone_name: [],
    state_name: "",
    start_weight: "",
    start_weight_unit_of_measurement: "",
    end_weight: "",
    end_weight_unit_of_measurement: "",
    price: "",
  };
  const [stateFilter, setStateFilter] = useState(intialFilter);
  const formRef = useRef();
  const [zones, setZones] = useState([]);
  const [states, setStates] = useState([]);
  const [countryName, setCountryName] = useState();
  const [unitofmeasurement, setunitofmeasurement] = useState([]);
  const [companyList, setCompanyList] = useState([]);

  useEffect(() => {
    getCountryName();
    authUserData()?.country
      ? getStateByCountry(authUserData()?.country)
      : getStateByCountry(1);
    authUserData()?.state
      ? getZoneByState(authUserData()?.state)
      : getZoneByState(1);

    getunitofmeasurement();
    getCompanyList();
  }, []);
  const handleCountrySelectChange = (value) => {
    setStateFilter((prevState) => {
      return {
        ...prevState,
        country: value,
        state: null,
      };
    });
    formRef.current.setFieldsValue({ state: null });
    setStates([]);
    getStateByCountry(value);
  };

  const getCountryName = async (data) => {
    await getRequest("country/?no_pagination=True", data).then((response) => {
      setCountryName(response?.data?.data);
    });
  };

  const handleStateSelectChange = (value) => {
    const selectedstate = states?.find((zone) => zone.id === value);
    const stateName = selectedstate ? selectedstate.name : "";
    setStateFilter((prevState) => ({
      ...prevState,

      state_name: stateName,
      zone_name: [],
    }));
    formRef.current.setFieldsValue({ zone: undefined });
    setZones([]);
    getZoneByState(value);
  };

  const getStateByCountry = async (id) => {
    const stateResponse = await getRequest(
      "state/?no_pagination=true&country_id=" + id
    );

    setStates(stateResponse?.data?.data);
  };

  const handlezoneChange = (selectedZones) => {
    setStateFilter((prevState) => ({
      ...prevState,
      zone_name: selectedZones,
      suburb_id: [],
    }));

    formRef.current.setFieldsValue({ suburb: undefined });
  };
  const handleCompanyChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      company: value,
    }));
  };

  const getZoneByState = async (id) => {
    const zoneResponse = await getRequest(
      "zone/?no_pagination=true&state_id=" + id
    );

    setZones(zoneResponse?.data?.data);
  };

  const handleunitofmeasurementChange = (value) => {
    setStateFilter((prevState) => {
      return {
        ...prevState,
        start_weight_unit_of_measurement: value,
      };
    });
  };
  const handleunitofmeasurementChangeEnd = (value) => {
    setStateFilter((prevState) => {
      return {
        ...prevState,
        end_weight_unit_of_measurement: value,
      };
    });
  };

  const getunitofmeasurement = async (data) => {
    await getRequest("unit-of-measurement/?no_pagination=True", data).then(
      (response) => {
        setunitofmeasurement(response?.data?.data);
      }
    );
  };

  const getCompanyList = async (data) => {
    await getRequest("company/?no_pagination=True", data).then((response) => {
      setCompanyList(response?.data?.data);
    });
  };

  const handleApplyFilter = async () => {
    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
  };

  const handleResetFilter = () => {
    setState({
      ...state,
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
    setStateFilter(intialFilter);
    form.setFieldsValue({ search: "" });

    setZones([]);
    setZones([]);
    formRef.current.setFieldsValue({
      company_name: undefined,
      country: undefined,
      state: undefined,
      zone: undefined,
      start_weight: undefined,
      start_weight_unit_of_measurement: undefined,
      end_weight: undefined,
      end_weight_unit_of_measurement: undefined,
      Price: undefined,
    });
  };
  const colors = ["#737373"];
  return (
    <>
      <section className="grid-sec">
        <div className="ListingTopBar">
          <div className="pagenamewrap">
            <div className="pagename">
              <h3>Delivery Rate</h3>

              <Breadcrumb className="Breadcrumb-Sec">
                <Breadcrumb.Item>
                  <Link to="/dashboard">{t("home")}</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>{t("Delivery Rate")}</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <Space>
              <div className="searchwrp">
                <Space direction="vertical">
                  <Form form={form}>
                    <Form.Item name="search" initialValue="">
                      <Search
                        prefix={
                          <img
                            src={SearchIcon}
                            alt="SearchIcon"
                            className="SearchIcon"
                            width={22}
                          />
                        }
                        placeholder={t("pl_search_list")}
                        onChange={searchCallbackDelayed}
                      />
                    </Form.Item>
                  </Form>
                </Space>
              </div>
              {state?.search ? (
                // <Tooltip title="Reset search">
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="button"
                  label={
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <UndoOutlined
                        style={{ fontSize: "16px", color: "#fff" }}
                      />{" "}
                      Reset
                    </span>
                  }
                  onClick={handleResetFilter}
                />
              ) : (
                // </Tooltip>
                ""
              )}
              {/* <Tooltip
                color={colors}
                placement="right"
                title={
                  <span style={{ color: "#fff" }}>
                    Create New Delivery Rate For Organizing.
                  </span>
                }
              > */}
              {authUserData()?.permission.includes(
                "settings|add_deliveryrates"
              ) && (
                <Button
                  className="BlueShadowBtn"
                  type="primary"
                  onClick={handleAdd}
                  style={{
                    width: 150,
                  }}
                  icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
                >
                  {t("pl_adddeliveryrate")}
                </Button>
              )}
              {/* </Tooltip> */}
              <Modal
                className="ModelPopupSec"
                title={
                  deliveryratesID ? t("Edit Delivery Rate") : t("Delivery Rate")
                }
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                wrapClassName="modal-wrapper"
                keyboard={false}
              >
                <Deliveryrate
                  zoneList={zoneList}
                  reload={reload}
                  setReload={setReload}
                  handleCancel={handleCancel}
                  deliveryratesID={deliveryratesID}
                  modalKey={modalKey}
                  setStateM={setState}
                />
              </Modal>

              <Modal
                className="ModelPopupSec"
                title="Upload File"
                open={isModalOpenBulk}
                onOk={handleOkBulk}
                onCancel={handleCancelBulk}
                closable={false}
                wrapClassName="modal-wrapper"
              ></Modal>
              {authUserData()?.permission.includes(
                "settings|delete_deliveryrates"
              ) && (
                <>
                  {selectedRow.length > 0 && (
                    <Popconfirm
                      className="action"
                      title={t("pop_delete")}
                      okText={t("pop_ok")}
                      cancelText={t("pop_cancel")}
                      placement="left"
                      onConfirm={() => handleArchive()}
                    >
                      <ButtonField
                        className="BlueShadowBtn"
                        type="primary"
                        htmlType="button"
                        label={
                          <>
                            <div
                              className="BlueShadowBtn"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <ArchiveButtonicon />
                              <span>{t("pl_archive")}</span>
                            </div>
                          </>
                        }
                      />
                    </Popconfirm>
                  )}
                </>
              )}
              {/* <Tooltip placement="topLeft" title="Column Filter Options"> */}
              <div className="gridiconswrap">
                <Dropdown
                  overlay={columnMenu}
                  trigger={["click"]}
                  placement="bottomRight"
                  overlayClassName="customdropdwn"
                  visible={dropdownVisible}
                  onVisibleChange={(visible) => setDropdownVisible(visible)}
                >
                  <Button
                    type="primary"
                    shape="circle"
                    icon={<InsertRowLeftOutlined />}
                    onClick={() => setDropdownVisible(!dropdownVisible)}
                  />
                </Dropdown>
              </div>
              {/* </Tooltip> */}
            </Space>
          </div>
        </div>
        <div className="Package-body">
          <div className="deliveryform-body">
            <div>
              <Form autoComplete="off" ref={formRef}>
                <Row className="deliveryformfilter">
                  <Col className="TextFeild">
                    <Form.Item
                      name="country"
                      label={t("pl_country")}
                      placeholder={t("pl_select_country")}
                    >
                      <Select
                        placeholder={t("pl_select_country")}
                        showArrow
                        showSearch
                        value={stateFilter?.country}
                        name="country"
                        optionFilterProp="children"
                        onChange={(value) => handleCountrySelectChange(value)}
                        style={{ width: "120px" }}
                      >
                        {countryName?.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="TextFeild gutter-row">
                    <Form.Item name="state" label={t("pl_state")}>
                      <Select
                        name="state"
                        label={t("pl_state")}
                        placeholder={t("pl_select_state")}
                        value={stateFilter.state}
                        onChange={handleStateSelectChange}
                        showArrow
                        showSearch
                        optionFilterProp="children"
                        style={{ width: "140px" }}
                      >
                        {states.map((state) => (
                          <Option key={state.id} value={state.id}>
                            {state.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="TextFeild gutter-row">
                    <Form.Item name="zone" label={t("pl_zone")}>
                      <Select
                        name="zone"
                        label={t("pl_zone")}
                        placeholder={t("val_zone")}
                        onChange={handlezoneChange}
                        value={stateFilter.zone}
                        showArrow
                        mode="multiple"
                        showSearch
                        optionFilterProp="children"
                        style={{ width: "100px" }}
                      >
                        {zones?.map((item) => (
                          <Option key={item.id} value={item.zone}>
                            {item.zone}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="TextFeild gutter-row">
                    <Form.Item name="company_name" label={t("Company")}>
                      <Select
                        name="company"
                        label={t("Company")}
                        placeholder={t("pl_select_company")}
                        onChange={(value) => handleCompanyChange(value)}
                        value={stateFilter?.company}
                        showArrow
                        showSearch
                        optionFilterProp="children"
                        style={{ width: "130px" }}
                      >
                        {companyList?.map((item) => (
                          <Option key={item.id} value={item.company}>
                            {item.company_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="TextFeild gutter-row">
                    <Form.Item
                      name="start_weight"
                      label={t("from_weight")}
                      initialValue={stateFilter?.start_weight}
                    >
                      <Input
                        type="text"
                        name="start_weight"
                        value={stateFilter?.start_weight}
                        onChange={(value) =>
                          handleChange("start_weight", value)
                        }
                        placeholder={t("from_weight")}
                        style={{ width: "100px" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col className="TextFeild gutter-row">
                    <Form.Item
                      name="start_weight_unit_of_measurement"
                      label={t("UoM.")}
                      placeholder={t("UoM.")}
                    >
                      <Select
                        placeholder={t("UoM.")}
                        showArrow
                        showSearch
                        value={state?.start_weight_unit_of_measurement}
                        name="start_weight_unit_of_measurement"
                        optionFilterProp="children"
                        onChange={(value) =>
                          handleunitofmeasurementChange(value)
                        }
                        style={{ width: "80px" }}
                      >
                        {unitofmeasurement?.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="TextFeild gutter-row">
                    <Form.Item
                      name="end_weight"
                      label={t("to_weight")}
                      initialValue={state?.end_weight}
                    >
                      <Input
                        type="text"
                        name="end_weight"
                        value={state?.end_weight}
                        onChange={(value) => handleChange("end_weight", value)}
                        placeholder={t("to_weight")}
                        style={{ width: "100px" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col className="TextFeild gutter-row">
                    <Form.Item
                      name="end_weight_unit_of_measurement"
                      label={t("UoM.")}
                      placeholder={t("UoM.")}
                    >
                      <Select
                        placeholder={t("label_unit_of_measurement")}
                        showArrow
                        showSearch
                        value={state?.end_weight_unit_of_measurement}
                        name="end_weight_unit_of_measurement"
                        optionFilterProp="children"
                        onChange={(value) =>
                          handleunitofmeasurementChangeEnd(value)
                        }
                        style={{ width: "80px" }}
                      >
                        {unitofmeasurement?.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  {/* <Tooltip placement="topLeft" title="Apply Filter"> */}
                  <Button
                    className="BlueShadowBtnRoute"
                    type="primary"
                    htmlType="button"
                    // label="Apply"
                    onClick={handleApplyFilter}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <FilterOutlined style={{ fontSize: "16px" }} /> Apply
                      Filter
                    </span>
                  </Button>
                  {/* </Tooltip> */}
                  {stateFilter?.country ||
                  stateFilter?.state_name ||
                  // stateFilter?.suburb_id.length!==0 ||
                  // stateFilter?.postcode_id.length!==0 ||
                  stateFilter?.zone_name.length !== 0 ||
                  stateFilter?.company ||
                  stateFilter?.start_weight ||
                  stateFilter?.start_weight_unit_of_measurement ||
                  stateFilter?.end_weight ||
                  stateFilter?.end_weight_unit_of_measurement ? (
                    // <Tooltip placement="topLeft" title="Reset Filter">
                    <Button
                      className="BlueShadowBtnRoute"
                      type="primary"
                      htmlType="Reset"
                      // label="Reset"
                      onClick={handleResetFilter}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <UndoOutlined
                          style={{ fontSize: "16px", color: "#fff" }}
                        />{" "}
                        Reset
                      </span>
                    </Button>
                  ) : (
                    // </Tooltip>
                    ""
                  )}
                </Row>
              </Form>
            </div>
          </div>

          <Table
            rowSelection={rowSelection}
            rowKey={(record) => record.id}
            columns={columns.filter((col) => !col.hidden)}
            dataSource={deliveryrates}
            scroll={{ x: 800 }}
            loading={loading}
            pagination={{
              current: state.page,
              pageSize: state.pagesize,
              total: totalCount,
              showSizeChanger: true,
              showTotal: (totalCount) => `Total ${totalCount} items`,
              locale: {
                items_per_page: "Items / Page", // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
        </div>
      </section>
    </>
  );
};

export default DeliveryRateList;
